import { composeQueryKey } from '../lib/composeQueryKey.js';

const getQueryKey = (qraftOptions, schema, args)=>{
    return composeQueryKey(schema, args[0]);
};

export { getQueryKey };
//# sourceMappingURL=getQueryKey.js.map
